import axios from "axios";
import { useSnackbar } from "notistack";
import { useQueries, useQuery } from "react-query";

interface SynoppticEntity {
    powerStationId: number,
    name: string,
    hasAlarmSound: boolean,
    status: {
        name: string;
        color: string;
    },
    synopticEquipmentList: Array<{
        status: {
            name: string;
            color: string;
        },
        offline: boolean,
        allEquipmentOffline: boolean,
        equipmentTypeId: number,
        count: number
    }>
}

interface Response {
    message: string;
    data: SynoppticEntity
}

const apiUrl = 'api/power-station/status/synoptic';

export const fetchSynopticData = async (powerStationId:number): Promise<Response> =>{
    try{
        return  await axios
            .get<Response>(`${apiUrl}/${powerStationId}`,{timeout:30000})
            .then((res) => {    console.log('SynopticCard render:', res.data);
return res.data})
    }catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }

}

const SynopticReactQuery = (powerStationId:number) => {
    return useQuery({
        queryKey: ['data', powerStationId],
        queryFn: () => fetchSynopticData(powerStationId),
        refetchInterval: 20000,
        enabled: powerStationId > 0,
    })
}

export const useSynopticDataList = (powerStationIds: number[], interval: number) => {
    const { enqueueSnackbar } = useSnackbar();
    return useQueries(
        powerStationIds.map((id) => ({
            queryKey: ['data', id],
            queryFn: () => fetchSynopticData(id),
            refetchInterval: interval,
            enabled: id > 0,
            onError: () => {
                enqueueSnackbar("Não foi possível buscar os dados. Tente novamente", {variant: 'error', autoHideDuration: 1500,})
            }
        }))
    );
};

export default SynopticReactQuery;